/**
 * @fileoverview GET handler for the "/apps/:app_group_id/encryption_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEncryptionSettings } from "./constants";
import type { UserDataEncryptionSettingsResult } from "./types";

export const getUserDataEncryptionSettings = reactQueryFetcherAdapter(
  appsAppGroupIdEncryptionSettings,
  (signal: AbortSignal, appGroupId: string): Promise<UserDataEncryptionSettingsResult> => {
    return fetch(`/apps/${appGroupId}/encryption_settings`, "GET", {}, { signal });
  }
);
